import React from 'react'
import Button from '../../Button'

interface ISubmitButtonProps {
  fullWidth?: boolean
  children: React.ReactNode
  onClick?: () => void
}

const SubmitButton = ({ children, fullWidth, onClick }: ISubmitButtonProps) => {
  return (
    <Button
      type="submit"
      variant="filled-rounded"
      size="large"
      fullWidth={fullWidth}
      onClick={onClick}
    >
      {children}
    </Button>
  )
}

SubmitButton.displayName = 'Form.SubmitButton'
export default SubmitButton
